import React from 'react';
import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { store, persistor } from 'app/store';
import App from 'app/App';
import reportWebVitals from './reportWebVitals';
import { SENTRY_DNS } from 'common/constants';

import 'common/styles/index.scss';

// @ts-expect-error not defined
if (!('process' in window)) window.process = {};

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: SENTRY_DNS,

    tracesSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
